"use client";

import React, { ReactElement } from "react";
import { type LayerSpecification } from "maplibre-gl";
import { RSource, RLayer } from "maplibre-react-components";
import { MissionType } from "@/types";
import { feature } from "@turf/turf";

interface MissionMapLibreLayerProps {
  mission: MissionType;
}

function MissionMapLibreLayer({
  mission,
}: Readonly<MissionMapLibreLayerProps>): ReactElement | null {
  const paint: LayerSpecification["paint"] = React.useMemo(
    () => ({
      "fill-color": "rgba(0,0,0,0.1)",
      "fill-outline-color": "rgba(0,0,0,0.3)",
    }),
    [],
  );

  if (mission.geometry) {
    const data = feature(mission.geometry);
    return (
      <>
        <RSource
          key="mission-source"
          id="mission-source"
          generateId={true}
          type="geojson"
          data={data}
          promoteId="mission_num2"
        />
        <RLayer
          key="mission-layer"
          id="mission-layer"
          source="mission-source"
          type="fill"
          paint={paint}
        />
      </>
    );
  }

  return null;
}

export { MissionMapLibreLayer };
